import React from 'react'
import { TextPage } from './TextPage'
import textForm from './texts/privacyPolicy'

export const PrivacyPolicy = () => {
  return <TextPage textForm={textForm} />
}
